/* tslint:disable */
/* eslint-disable */
/**
 * Linqx API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JoinWaitlistDto
 */
export interface JoinWaitlistDto {
    /**
     * Email address to join the waitlist
     * @type {string}
     * @memberof JoinWaitlistDto
     */
    email: string;
    /**
     * Name of the person joining the waitlist
     * @type {string}
     * @memberof JoinWaitlistDto
     */
    name?: string;
    /**
     * Where the user heard about Linqx
     * @type {string}
     * @memberof JoinWaitlistDto
     */
    referralSource?: string;
}

/**
 * Check if a given object implements the JoinWaitlistDto interface.
 */
export function instanceOfJoinWaitlistDto(value: object): value is JoinWaitlistDto {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function JoinWaitlistDtoFromJSON(json: any): JoinWaitlistDto {
    return JoinWaitlistDtoFromJSONTyped(json, false);
}

export function JoinWaitlistDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JoinWaitlistDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'name': json['name'] == null ? undefined : json['name'],
        'referralSource': json['referralSource'] == null ? undefined : json['referralSource'],
    };
}

export function JoinWaitlistDtoToJSON(json: any): JoinWaitlistDto {
    return JoinWaitlistDtoToJSONTyped(json, false);
}

export function JoinWaitlistDtoToJSONTyped(value?: JoinWaitlistDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'name': value['name'],
        'referralSource': value['referralSource'],
    };
}

